import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import styles from "./SlideCompositionPage.local.scss";

const options = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" }
];

class SelectNumberYears extends React.Component {
  state = {
    selectedOption: null
  };
  handleChange = selectedOption => {
    if (selectedOption) {
      this.setState({ selectedOption: selectedOption });
      this.props.selectYear(selectedOption.value);
    } else {
      this.setState({ selectedOption: null });
    }
  };
  render() {
    const { selectedOption } = this.state;
    let updateNmbrYears = {
      label: this.props.configUpdate.nbrOfYears
        ? this.props.configUpdate.nbrOfYears
        : "",
      value: this.props.configUpdate.nbrOfYears
        ? this.props.configUpdate.nbrOfYears
        : ""
    };
    return (
      <Select
        className={styles.input_nbr_years}
        value={
          updateNmbrYears.label && this.props.update === "UPDATE"
            ? updateNmbrYears
            : selectedOption
        }
        onChange={this.handleChange}
        options={options}
        classNamePrefix="ttp-select"
        width={"12px"}
        isClearable={true}
      />
    );
  }
}
const mapStateToProps = state => ({
  update: state.slideComposition.ComponentAction
});

export default connect(mapStateToProps)(SelectNumberYears);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/SelectNumberYears.js